/* eslint-disable camelcase, import/prefer-default-export */
import { AxiosResponse } from 'axios';

export const API = 'account/common/captcha';

/** ID */
export type p34_mge_id = number

export interface request extends lists {

}

export interface AxiosResponse extends AxiosResponse<responseExtends> { }

interface responseExtends extends backendResponse {
}

export type response = {

}
